import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Plus, Grid } from 'lucide-react';

const ExamSettingsTab = ({
  exams,
  rooms,
  gradeConfig,
  selectedExam,
  onSelectExam,
  onAddRoom,
  onGenerateSeating
}) => {
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">⚙️ Exam Settings</h2>
      
      <div className="grid md:grid-cols-2 gap-4">
        {/* Exam Rooms */}
        <Card>
          <CardHeader>
            <div className="flex justify-between items-center">
              <CardTitle className="text-base">Exam Rooms</CardTitle>
              <Button size="sm" onClick={onAddRoom}>
                <Plus className="h-3 w-3 mr-1" /> Add Room
              </Button>
            </div>
          </CardHeader>
          <CardContent>
            {rooms.length > 0 ? (
              <div className="space-y-2">
                {rooms.map(r => (
                  <div key={r.id} className="flex justify-between items-center p-2 bg-muted/50 rounded">
                    <span className="font-medium">{r.room_number}</span>
                    <span className="text-sm text-muted-foreground">Capacity: {r.capacity}</span>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-muted-foreground text-sm">No rooms added</p>
            )}
          </CardContent>
        </Card>

        {/* Grade Configuration */}
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Grade Configuration</CardTitle>
            <CardDescription>CBSE grading pattern</CardDescription>
          </CardHeader>
          <CardContent>
            {gradeConfig?.grades && gradeConfig.grades.length > 0 ? (
              <div className="space-y-1">
                {gradeConfig.grades.map((g) => (
                  <div key={g.grade} className="flex justify-between items-center p-2 bg-muted/50 rounded">
                    <div className="flex items-center gap-2">
                      <span className="font-bold text-primary">{g.grade}</span>
                      <span className="text-xs text-muted-foreground">({g.remarks})</span>
                    </div>
                    <span className="text-sm font-medium">{g.min_marks}% - {g.max_marks}%</span>
                  </div>
                ))}
                <div className="mt-3 pt-3 border-t flex justify-between">
                  <span className="text-sm text-muted-foreground">Pass Percentage:</span>
                  <span className="font-bold text-green-600">{gradeConfig.pass_percentage}%</span>
                </div>
              </div>
            ) : (
              <p className="text-muted-foreground text-sm">Default CBSE grades applied</p>
            )}
          </CardContent>
        </Card>

        {/* Seating Arrangement */}
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Seating Arrangement</CardTitle>
            <CardDescription>Auto-generate seating for exams</CardDescription>
          </CardHeader>
          <CardContent className="space-y-3">
            <Select value={selectedExam?.id || ''} onValueChange={onSelectExam}>
              <SelectTrigger><SelectValue placeholder="Select Exam" /></SelectTrigger>
              <SelectContent>
                {exams.map(e => <SelectItem key={e.id} value={e.id}>{e.name}</SelectItem>)}
              </SelectContent>
            </Select>
            <Button className="w-full" onClick={() => onGenerateSeating(selectedExam?.id)} disabled={!selectedExam}>
              <Grid className="h-4 w-4 mr-2" /> Generate Seating
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ExamSettingsTab;
